import React from "react";
import { TableRow, TableHead } from "material-ui";
import CustomTableCell from "../controls/CustomTableCell";
import DeleteButton from "../controls/DeleteButton";

const headerStyle = {
  background: "#ffffff",
  color: "#7b8b85",
  fontSize: 10,
  fontWeight: 800,
  textTransform: "uppercase",
  letterSpacing: "0.7px",
  borderBottom: "1px solid #e8efec",
  paddingTop: 12,
  paddingBottom: 12
};

const CartHeader = ({ isCartEmpty, onDeleteAll }) => (
  <TableHead>
    <TableRow>
      <CustomTableCell
        style={{
          ...headerStyle,
          width: 150,
          textAlign: "left",
          paddingLeft: 16
        }}
      >
        Product
      </CustomTableCell>

      <CustomTableCell
        numeric
        style={headerStyle}
      >
        Price
      </CustomTableCell>

      <CustomTableCell
        numeric
        style={{
          ...headerStyle,
          textAlign: "center"
        }}
      >
        Qty
      </CustomTableCell>

      <CustomTableCell
        numeric
        style={{
          ...headerStyle,
          color: "#16845b"
        }}
      >
        Total
      </CustomTableCell>

      <CustomTableCell
        numeric
        style={{
          ...headerStyle,
          width: 42,
          paddingRight: 8
        }}
      >
        {!isCartEmpty && (
          <DeleteButton onDelete={onDeleteAll} />
        )}
      </CustomTableCell>
    </TableRow>
  </TableHead>
);

export default CartHeader;
